import { TVersionedResource } from "./interfaces";
import { pathwayVersionedResource } from "app/_modules/pathways/api";
import { reportsVersionedResource, appointmentReportsVersionedResource } from "app/_modules/history/api";
import { subscriptionsVersionedResource } from "app/_modules/user/api";
import { coreVersionedResource } from "app/_modules/core/api";

export const API_ROUTE_VERSION: TVersionedResource = {
    ...pathwayVersionedResource,
    ...reportsVersionedResource,
    ...appointmentReportsVersionedResource,
    ...subscriptionsVersionedResource,
    ...coreVersionedResource,
  };
